class SockMatchBlock extends HTMLElement {
    connectedCallback() {
        this.data = JSON.parse(this.querySelector('[data-sock-match-json]').textContent);
        this.chipsEl = this.querySelector('[data-sock-chips]');
        this.tilesEl = this.querySelector('[data-sock-tiles]');
        this.blurbEl = this.querySelector('[data-sock-blurb]');

        const currentVariantId = this.dataset.currentVariantId;
        const initialEntry = this.data[currentVariantId];
        this.currentMatches = initialEntry?.matches || [];
        this.currentShoeColor = initialEntry?.shoe_color;

        document.addEventListener('variant:change', (e) => this.onVariantChange(e));

        this.chipsEl?.addEventListener('click', (e) => {
            const chip = e.target.closest('.sock-match__chip');
            if (!chip) return;
            this.chipsEl.querySelectorAll('.sock-match__chip').forEach((c) => {
            const on = c === chip;
            c.classList.toggle('is-selected', on);
            c.setAttribute('aria-checked', on);
            });
            this.renderTiles(chip.dataset.sockName);
        });
    }

  onVariantChange(e) {
    const entry = this.data[e.detail.variant.id];
    if (!entry || entry.matches.length === 0) {
      console.warn(`Sock match: no data for variant ${e.detail.variant.id}`);
      this.classList.add('sock-match--hidden');
      return;
    }
    this.classList.remove('sock-match--hidden');
    this.currentMatches = entry.matches;
    this.currentShoeColor = entry.shoe_color;
    this.renderBlurb();
    this.renderChips();
    this.renderTiles(entry.matches[0].name);
  }

  renderBlurb() {
    if (!this.blurbEl) return;
    const n = this.currentMatches.length;
    const words = ['', 'One', 'Two', 'Three', 'Four'];
    this.blurbEl.textContent =
      `${words[n]} Hosiery Plus color${n !== 1 ? 's' : ''} pair${n === 1 ? 's' : ''} with ${this.currentShoeColor}.` +
      (n > 1 ? ' Pick the one you like.' : '');
  }

        renderChips() {
        if (!this.chipsEl) return;
        this.chipsEl.innerHTML = '';
        this.currentMatches.forEach((m, i) => {
            const chip = document.createElement('button');
            chip.type = 'button';
            chip.className = `sock-match__chip${i === 0 ? ' is-selected' : ''}`;
            chip.setAttribute('role', 'radio');
            chip.setAttribute('aria-checked', i === 0);
            chip.dataset.sockName = m.name;
            chip.innerHTML = `<span class="sock-match__chip-swatch" style="background-color: ${m.color || '#ccc'};"></span><span>${m.name}</span>`;
            chip.addEventListener('click', () => {
            this.chipsEl.querySelectorAll('.sock-match__chip').forEach((c) => {
                c.classList.toggle('is-selected', c === chip);
                c.setAttribute('aria-checked', c === chip);
            });
            this.renderTiles(m.name);
            });
            this.chipsEl.appendChild(chip);
        });
        }

        renderTiles(selectedName) {
        const m = this.currentMatches.find((x) => x.name === selectedName) || this.currentMatches[0];
        if (!m) return;
        ['anklet', 'crew', 'knee_high'].forEach((length) => {
            const tile = this.tilesEl.querySelector(`[data-tile="${length}"]`);
            if (!tile) return;
            const url = m[length];
            if (!url) {
            tile.classList.add('sock-match__tile--hidden');
            tile.removeAttribute('href');
            return;
            }
            tile.classList.remove('sock-match__tile--hidden');
            tile.href = url;
            tile.querySelector('[data-tile-code]').textContent = m[`code_${length}`] || '';
            const img = tile.querySelector('.sock-match__tile-swatch');
            if (img && m[`swatch_${length}`]) img.setAttribute('src', m[`swatch_${length}`]);
        });
        }
}
if (!customElements.get('sock-match-block')) {
  customElements.define('sock-match-block', SockMatchBlock);
}